import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { ChapterArt } from "@/components/ChapterArt";
import { contact } from "@/content/siteContent";

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <header className="bg-sand">
        <div className="relative mx-auto max-w-6xl px-6 pb-20 pt-20 sm:pt-28">
          <div className="hidden sm:block">
            <ChapterArt testId="page-art-contact" />
          </div>
          <Reveal>
            <p className="eyebrow">Contact</p>
            <h1 className="mt-6 max-w-3xl text-4xl font-black leading-tight tracking-tighter sm:text-5xl">
              Let’s talk about the business question you’re working on.
            </h1>
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-muted sm:text-lg">
              Whether it’s strategy, research, analytics, reporting, or an AI-enabled workflow you’re
              exploring — email is the fastest way to reach me.
            </p>
          </Reveal>
        </div>
      </header>

      <section className="bg-white">
        <div className="mx-auto max-w-6xl px-6 py-20 sm:py-28">
          <Reveal delay={0.1}>
            <div className="py-4">
              <p className="eyebrow">
                <span className="font-bold text-terracotta">01</span> / Email
              </p>
              <a
                href={`mailto:${contact.email}`}
                className="editorial-link mt-5 inline-block break-all text-2xl font-bold tracking-tight sm:text-4xl"
                data-testid="contact-email-link"
              >
                {contact.email}
              </a>
            </div>
          </Reveal>
          <div className="my-8 h-px w-full bg-ink/15" aria-hidden="true" />
          <Reveal delay={0.2}>
            <div className="py-4">
              <p className="eyebrow">
                <span className="font-bold text-terracotta">02</span> / LinkedIn
              </p>
              <a
                href={contact.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="editorial-link mt-5 inline-flex items-center gap-3 text-2xl font-bold tracking-tight sm:text-4xl"
                data-testid="contact-linkedin-link"
              >
                {contact.linkedinLabel} <ArrowUpRight size={28} aria-hidden="true" />
              </a>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
